import React, { useEffect } from "react";
import { FaUserPlus, FaUserCheck, FaUserTimes } from "react-icons/fa";
import frnds from "../assets/frnds.png";
import ellipse from "../assets/Ellipse 1.png";
import pipaanlogo from "../assets/pipaanlogo.png";
import newsfeed from "../assets/images/icons/newsfeed.png";
import friendsfollowers from "../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../assets/images/icons/groupandfamily.png";
import chats from "../assets/images/icons/chats.png";
import profile from "../assets/images/icons/profile.png";
import Account from "../assets/images/icons/account-setting.png";
import help from "../assets/images/icons/helpandsupport.png";
import logout from "../assets/images/icons/logout.png";

import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar"; // Import scrollbar styles
import { FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown } from "react-icons/fa";
import groupimg from "../assets/groupimg.png";
import userimg from "../assets/user.png";
import profileimg from "../assets/profile.png";
import share from "../assets/share.png";
import notification from "../assets/images/icons/notification.png";
import hamburger from "../assets/images/icons/hamburger.png";
import hamburgerclose from "../assets/images/icons/hamburgerclose.png";
import closecircle from "../assets/images/icons/close-circle.png";
import FeedPost from "./feedpost/FeedPost";
import postData from "./feedpost/postdata";
import { Menu, X, Bell, User } from "lucide-react"; // Icons
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaTimes } from "react-icons/fa";
import { useState } from "react";
import profilebanner from "../assets/images/Profile-banner.png";
import Leftsidebar from "../components/sidebar/leftsidebar"
import LeftResponsivesidebar from "../components/sidebar/left-responsive"
import Rightsidebar from "../components/sidebar/rightsidebar"
import RightResponsivesidebar from "../components/sidebar/right-responsive"
import Headmenu from "../components/sidebar/headmenu"
import profileData from "./feedpost/profiledata";

const friends = [
  { id: 1, name: "Websters Shivaji", followers: 764, img: ellipse },
  { id: 2, name: "Websters Shivaji", followers: 764, img: ellipse },
  { id: 3, name: "Websters Shivaji", followers: 764, img: ellipse },
];


export default function FriendsPage() {
  const [friendRequests, setFriendRequests] = useState([]);
  const [followingList, setFollowingList] = useState([]); // ✅ New state for accepted friends
  const [acceptedFriendIds, setAcceptedFriendIds] = useState([]); // ✅ Only store accepted IDs
  const [followings, setFollowings] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [error, setError] = useState(null);
  const [followingsTotal, setFollowingsTotal] = useState(0);  // ✅ Total followings count
  const [followersTotal, setFollowersTotal] = useState(0);    // ✅ Total followers count
  const [followerFollowStatus, setFollowerFollowStatus] = useState({}); // Track follow status for followers
  const [followedUsers, setFollowedUsers] = useState({});  // ✅ Track clicked users
  const [blockedUsers, setBlockedUsers] = useState({}); // Track blocked users
  const [searchQuery, setSearchQuery] = useState("");

  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);

  // ✅ Separate function for toggling state
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("Following");
  const friendsList = [1, 2, 3, 4]; // Replace with actual friends data
  const followersList = [1, 2, 3, 4, 5, 6]; // Replace with actual followers data


  // ✅ Fetch friends API
  const fetchFriends = async () => {
    const token = sessionStorage.getItem("accessToken");  // Retrieve token from localStorage

    if (!token) {
      console.error("No token found, please log in.");
      return;
    }

    // ✅ Retrieve the userID inside the function to ensure it is always fetched fresh
    const userID = sessionStorage.getItem("userID");
    console.log("userID:", userID);

    if (!userID) {
      console.error("No user ID found in sessionStorage.");
      return;
    }
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/get-friends", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`, // ✅ Ensure proper format
        },
        body: JSON.stringify({
          filters: {
            status: "pending",
            user_id_2: userID,
          },
          page: 1,
          limit: 10

        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);
      const formattedFriends = data.result.friends.map((friend) => ({
        id: friend.id,
        friend_id: friend.id,   // Store friend_id from response
        first_name: friend.User1.first_name,
        username: friend.User1.username,
        profile_picture_url: friend.User1.profile_picture_url || userimg,
        mutualFriendsCount: friend.mutualFriendsCount || 0,
      }));

      setFriendRequests(formattedFriends);
    } catch (error) {
      console.error("Error fetching friends:", error);
    } finally {
      setLoading(false);
    }
  };
  // ✅ Accept friend request
  const editFriendStatus = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");

    if (!token) {
      console.error("No token found, please log in.");
      return;
    }

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/edit-friend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          friend_id: friendId,
          status: "accepted",
          is_deleted: false,
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const result = await response.json();
      console.log("Friend accepted:", result);
      // ✅ Find the accepted friend
      const acceptedFriend = friendRequests.find((friend) => friend.id === friendId);

      if (acceptedFriend) {
        // ✅ Add accepted friend to `followingList`
        setFollowers((prev) => [...prev, acceptedFriend]);

        // ✅ Remove from pending friend requests
        setFriendRequests((prev) => prev.filter((friend) => friend.id !== friendId));
      }
    } catch (error) {
      console.error("Error accepting friend:", error);
    }
  };

  useEffect(() => {
    fetchFriends();
  }, []);

  // ✅ Add this function for rejecting friend requests
  const rejectFriendRequest = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");

    if (!token) {
      console.error("No token found, please log in.");
      return;
    }

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/edit-friend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          friend_id: friendId,
          status: "rejected",
          is_deleted: true,    // ✅ Reject and mark as deleted
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const result = await response.json();
      console.log("Friend request rejected:", result);

      // ✅ Remove the rejected friend from the list
      setFriendRequests((prev) => prev.filter((friend) => friend.id !== friendId));

    } catch (error) {
      console.error("Error rejecting friend request:", error);
    }
  };


  // ✅ Fetch Followings
  const fetchFollowings = async (search = "") => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
    const userID = sessionStorage.getItem("userID");

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/get-friends", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          filters: { allFollowings: true,search },
          page: 1,
          limit: 10,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      console.log("Followings Response:", data.result);   // ✅ Debugging log

      // ✅ Store user2id with corresponding friend_id in sessionStorage
      const user2IdMap = data.result.friends.reduce((acc, friend) => {
        acc[friend.id] = friend.User2.id;  // friend_id => user2id
        return acc;
      }, {});

      sessionStorage.setItem("user2IdMap", JSON.stringify(user2IdMap));
      // ✅ Ensure you're extracting the correct total count
      const totalFollowings = data.result.total || 0;
      setFollowingsTotal(totalFollowings);
      const formattedFollowings = data.result.friends.map((friend) => ({
        id: friend.id,
        friend_id: friend.id,
        first_name: friend.User2.first_name,
        user2id: friend.User2.id,

        username: friend.User2.username,
        profile_picture_url: friend.User2.profile_picture_url || userimg,
        mutualFriendsCount: friend.mutualFriendsCount || 0,
      }));
      console.log("formattedFollowings::", formattedFollowings)
      setFollowings(formattedFollowings);
    } catch (error) {
      console.error("Error fetching followings:", error);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchFollowings(searchQuery); // Fetch followers with the search query
    }, 500); // Add a debounce delay to avoid excessive API calls
  
    return () => clearTimeout(delayDebounceFn); // Cleanup the timeout
  }, [searchQuery]);
  // ✅ Fetch Followers
  const fetchFollowers = async (search = "") => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
    // const userID = sessionStorage.getItem("userID");

    const userID = sessionStorage.getItem("userID");
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/get-friends", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          filters: { allFollowers: true,search},
          page: 1,
          limit: 10,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      // ✅ Store user2id with corresponding friend_id in sessionStorage
      const user1IdMap = data.result.friends.reduce((acc, friend) => {
        acc[friend.id] = friend.User1.id;  // friend_id => user2id
        return acc;
      }, {});

      sessionStorage.setItem("user1IdMap", JSON.stringify(user1IdMap));
      // ✅ Extract the `total` value for correct count
      setFollowersTotal(data.result.total);
      const formattedFollowers = data.result.friends.map((friend) => {
        const user1id = friend.User1.id;
  
        // ✅ Store user1id in sessionStorage
        sessionStorage.setItem(`user1id_${friend.friend_id}`, user1id);
  
        return {
          id: friend.id,
          friend_id: friend.id,
          user1id: user1id, // Store user1id
          first_name: friend.User1.first_name,
          username: friend.User1.username,
          profile_picture_url: friend.User1.profile_picture_url || userimg,
          mutualFriendsCount: friend.mutualFriendsCount || 0,
          user1FollowersCount: friend.user1FollowersCount || 0,
          myStatus: friend.myStatus,  // ✅ Store myStatus
          friendStatus: friend.friendStatus,  // ✅ Store friendStatus

        };
      });
  
console.log("formattedFollowers :",formattedFollowers)

      setFollowers(formattedFollowers);
    } catch (error) {
      console.error("Error fetching followers:", error);
    }
  };

  useEffect(() => {
    fetchFriends();
    fetchFollowings();
    fetchFollowers();
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchFollowers(searchQuery); // Fetch followers with the search query
    }, 500); // Add a debounce delay to avoid excessive API calls
  
    return () => clearTimeout(delayDebounceFn); // Cleanup the timeout
  }, [searchQuery]);

  const highlightText = (text, search) => {
    if (!search) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, (match) => `<span class="highlight">${match}</span>`);
  };
  const handleUnfollow = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
 // ✅ Show confirmation popup
 const isConfirmed = window.confirm("Are you sure you want to unfollow this user?");
 if (!isConfirmed) return; // Stop execution if user cancels

    // ✅ Retrieve the user2id from sessionStorage
    const user2IdMap = JSON.parse(sessionStorage.getItem("user2IdMap")) || {};

    // Get the corresponding user2id from the friendId
    const user2id = user2IdMap[friendId];

    if (!user2id) {
      console.error(`User2 ID not found for friend ID: ${friendId}`);
      return;
    }
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/add-friend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "deleted",    // ✅ Use "unfollow" status
          user_id: user2id,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      console.log(`Unfollowed user ID: ${user2id}`);

      // ✅ Remove the user from the followings state
      setFollowings((prev) => prev.filter((user) => user.id !== friendId));

    } catch (error) {
      console.error("Error unfollowing:", error);
    }
  };

  const handleBlock = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
 // ✅ Show confirmation popup
 const isConfirmed = window.confirm("Are you sure you want to block this user?");
 if (!isConfirmed) return; // Stop execution if user cancels

    // ✅ Retrieve the user2id from sessionStorage
    const user2IdMap = JSON.parse(sessionStorage.getItem("user2IdMap")) || {};

    // Get the corresponding user2id from the friendId
    const user2id = user2IdMap[friendId];

    if (!user2id) {
      console.error(`User2 ID not found for friend ID: ${friendId}`);
      return;
    }
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/add-friend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "blocked",   // ✅ Use "blocked" status
          user_id: user2id,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      console.log(`Blocked user ID: ${user2id}`);

      // ✅ Update UI to show "Unblock" instead of Unfollow/Block
    setFollowings((prev) =>
      prev.map((user) =>
        user.id === friendId ? { ...user, isBlocked: true } : user
      )
    );

    } catch (error) {
      console.error("Error blocking:", error);
    }
  };
  const handleBlockFollower = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

     // ✅ Show confirmation popup
  const isConfirmed = window.confirm("Are you sure you want to block this user?");
  if (!isConfirmed) return; // Stop execution if user cancels

    // ✅ Retrieve the user2id from sessionStorage
    const user1IdMap = JSON.parse(sessionStorage.getItem("user1IdMap")) || {};

    // Get the corresponding user2id from the friendId
    const user1id = user1IdMap[friendId];

    if (!user1id) {
      console.error(`User2 ID not found for friend ID: ${friendId}`);
      return;
    }
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/add-friend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "blocked",   // ✅ Use "blocked" status
          user_id: user1id,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      console.log(`Blocked user ID: ${user1id}`);

      // ✅ Remove the user from the followings state
      // setFollowings((prev) => prev.filter((user) => user.id !== friendId));

       // ✅ Update UI to show "Unblock" instead of Unfollow/Block
    setFollowers((prev) =>
      prev.map((user) =>
        user.id === friendId ? { ...user, isBlocked: true } : user
      )
    );

      // window.location.reload();

    } catch (error) {
      console.error("Error blocking:", error);
    }
  };

  const handleFollowerAction = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
  
  // ✅ Get `user1id` from state instead of sessionStorage
  const user = followers.find((f) => f.id === friendId);
  if (!user || !user.user1id) {
    console.error("User1 ID not found.");
    return;
  }

  console.log("UserID being sent:", user.user1id); // ✅ Debugging log

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/add-friend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "pending",    // ✅ Use "unfollow" status
          user_id: user.user1id        }), 
      });
  
      if (!response.ok) throw new Error(`Error: ${response.status}`);
  
      // Update follow status in state
      setFollowerFollowStatus((prev) => ({
        ...prev,
        [friendId]: true, // Mark the user as followed
      }));
  
      // Refresh followers and followings lists
      fetchFollowers();
      fetchFollowings();
  
    } catch (error) {
      console.error("Error handling follower action:", error);
    }
  };
  const handleFollowBack = (friendId) => {
    handleFollowerAction(friendId); // Call API function to follow
    setFollowedUsers((prev) => ({ ...prev, [friendId]: true })); // Mark as followed
  };
  

  const handleUnblock = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
  
    // ✅ Show confirmation popup
    const isConfirmed = window.confirm("Are you sure you want to unblock this user?");
    if (!isConfirmed) return; // Stop execution if user cancels
    // ✅ Retrieve the user2id from sessionStorage
    const user2IdMap = JSON.parse(sessionStorage.getItem("user2IdMap")) || {};

    // Get the corresponding user2id from the friendId
    const user2id = user2IdMap[friendId];

    if (!user2id) {
      console.error(`User2 ID not found for friend ID: ${friendId}`);
      return;
    }
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/add-friend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "unblock",   // ✅ Use "blocked" status
          user_id: user2id,
        }),
      });
  
      if (!response.ok) throw new Error(`Error: ${response.status}`);
  
      console.log(`✅ Unblocked user ID: ${friendId}`);
  
      // ✅ Update UI to show Follow/Block buttons again
      setFollowings((prev) =>
        prev.map((user) =>
          user.id === friendId ? { ...user, isBlocked: false } : user
        )
      );
  
    } catch (error) {
      console.error("❌ Error unblocking:", error);
    }
  };
  
  const handleUnblockFollower = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
  
    // ✅ Show confirmation popup
    const isConfirmed = window.confirm("Are you sure you want to unblock this user?");
    if (!isConfirmed) return; // Stop execution if user cancels
   // ✅ Get `user1id` from state instead of sessionStorage
   const user = followers.find((f) => f.id === friendId);
   if (!user || !user.user1id) {
     console.error("User1 ID not found.");
     return;
   }
 
   try {
    const response = await fetch("https://pipaan.com360degree.com/api/friend/add-friend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "token": `${token}`,
      },
      body: JSON.stringify({
        status: "unblock",   // ✅ Use "blocked" status
        user_id: user.user1id ,
      }),
    });
  
      if (!response.ok) throw new Error(`Error: ${response.status}`);
  
      console.log(`✅ Unblocked user ID: ${friendId}`);
  
      // ✅ Update UI to show Follow/Block buttons again
      setFollowers((prev) =>
        prev.map((user) =>
          user.id === friendId ? { ...user, isBlocked: false } : user
        )
      );
  
    } catch (error) {
      console.error("❌ Error unblocking:", error);
    }
  };
  
  return (
    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />


      <main className="flex-1 p-6">
        <LeftResponsivesidebar />
        <Headmenu />
        {/* Main Content */}
        <main className="flex ">

          {/* Feeds */}
          <div className="flex-1 lg:pr-5 space-y-6">

            <div className="flex  space-x-4 mt-4">
              <div className="slider-md-swiper">
                <aside className=" bg-white p-3  ">
                  <div className="">
                    {/* Followers Section */}
                    <h3 className="text-xl font-bold">Friend Requests</h3>
                    {loading ? (
                      <p>Loading...</p>
                    ) : friendRequests.length === 0 ? (
                      <p>No friend requests found.</p>
                    ) : (
                      <Swiper
                        spaceBetween={10}
                        slidesPerView={3} // Number of visible slides
                        navigation={false} // Disable navigation buttons
                        scrollbar={{ hide: false, draggable: true }} // Show scrollbar and make it draggable
                        modules={[Navigation, Pagination, Scrollbar]} // Include Scrollbar module
                        className="relative" // Add relative positioning
                      >
                        {friendRequests.map((user) => (
                          <SwiperSlide key={user.id}>
                            <div className="swiper-friendsfollowers bg-white">
                              <img src={user.profile_picture_url} alt={user.first_name} className="rounded-lg w-full" />
                              <h4 className="text-center font-semibold mt-2 text-[22px]">{user.first_name}</h4>
                              <p className="text-center text-sm my-1 text-gray-500">@{user.username}</p>
                              <p className="text-center italic underline text-[18px] text-[#09522899]">
                                {user.mutualFriendsCount || 0} Mutual Followers
                              </p>
                              <div className="cta flex justify-center mt-5 space-x-2">
                                <button
                                  onClick={() => editFriendStatus(user.id)} // ✅ Call accept API

                                  className="accept bg-[#095228] text-white px-6 py-3 rounded-full flex items-center">
                                  Accept
                                </button>
                                <button
                                  onClick={() => rejectFriendRequest(user.id)}  // Reject the friend request

                                  className="reject bg-[#fff] border-[#BE1F2E] text-[#BE1F2E] px-6 py-3 rounded-full flex items-center">
                                  Reject
                                </button>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                  </div>
                </aside>
              </div>
            </div>
            <div className="feed-tabs profile-page-feeds w-full mx-auto text-center lg:text-left">
              <div className="flex items-center gap-x-6 justify-between">
                <div className="filter bg-[] lg:p-3 flex space-x-4">
                  {["Following", "Followers"].map((tab) => (
                    <button
                      key={tab}
                      className={`lg:p-3 friends-flowers-tab  ${activeTab === tab
                        ? "active focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                        : "text-black "
                        } focus:outline-none`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab} <span className="tab-user-count ml-1 text-[#fff] bg-[#095228]">{tab === "Following" ? followings.length : followers.length}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Tab Content */}
              <div className="mt-4">
                {activeTab === "Following" && (
                  <div className="friends-tab">
                    <div className="flex relative w-full">
                      <div className="fasearch">
                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                      </div>
                      <input
                        type="text"
                        placeholder="Find Your Friend"
                        value={searchQuery}
                        onChange={handleSearchChange} // Update search query on input change
                       
                        className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300"
                      />
                    </div>
                    {followings.length > 0 ? (

                    followings.map((user) => (

                      <div key={user.id}
                        className="followers followers-friends-profile justify-between border-b-2 border-[#161f2833] pb-6"
                      >
                        <div className="flex">
                          <img src={user.User2?.profile_picture_url || userimg} alt="User" className="w-15 h-15 rounded-full" />
                          <div className="pl-4">
                            <p className="titlesemibold pb-1">{user.first_name}</p>
                            <p className="text-[12px] text-[#747474] pb-1">@{user.username}</p>
                            <p className="members">
                              {user.mutualFriendsCount} Mutual Followers
                            </p>
                          </div>
                        </div>
                        <div className="flex follow-unfollow-cta">
                        {user.isBlocked ? (
        // ✅ Show Unblock button if user is blocked
        <button className="unblock-cta my-2 bg-green-500 text-white px-4 py-2 rounded"
          onClick={() => handleUnblock(user.id)}
        >
          Unblock
        </button>
      ) : (
        // ✅ Show Unfollow & Block buttons if user is NOT blocked
        <>
          <button className="follow-cta my-2" onClick={() => handleUnfollow(user.id)}>
            Unfollow
          </button>
          <button className="follow-cta-block my-2" onClick={() => handleBlock(user.id)}>
            Block
          </button>
        </>
      )}
                      </div>
          </div>
        ))
      ) : (
        <p className="text-center text-gray-500 mt-4">You have no following.</p>
      )}
    </div>
  )}
             {activeTab === "Followers" && (
    <div className="friends-tab">
      <div className="flex relative w-full">
        <div className="fasearch">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
        </div>
        <input
          type="text"
          placeholder="Find Your Friend"
          value={searchQuery}
          onChange={handleSearchChange} // Update search query on input change
         
          className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300"
        />
      </div>

      {followers.length > 0 ? (
        followers.map((user) => (
          <div
            key={user.id}
            className="followers followers-friends-profile justify-between border-b-2 border-[#161f2833] pb-6"
          >
            <div className="flex">
              <img
                src={user.profile_picture_url}
                alt="User"
                className="w-15 h-15 rounded-full"
              />
              <div className="pl-4">
              <p
            className="titlesemibold pb-1"
            dangerouslySetInnerHTML={{
              __html: highlightText(user.first_name, searchQuery),
            }}
          ></p>
<p
            className="text-[12px] text-[#747474] pb-1"
            dangerouslySetInnerHTML={{
              __html: highlightText(user.username, searchQuery),
            }}
          ></p>                <p className="members">
                  {user.user1FollowersCount} Followers{" "}
                  <span className="text-[#D9D9D9]">|</span>{" "}
                  <span className="italic text-[#095228b8] text-[10px] underline">
                    {user.mutualFriendsCount} Mutual Followers
                  </span>
                </p>
              </div>
            </div>
            <div className="flex follow-unfollow-cta">
              {user.isBlocked ? (
                <button
                  className="unblock-cta my-2 bg-green-500 text-white px-4 py-2 rounded"
                  onClick={() => handleUnblockFollower(user.id)}
                >
                  Unblock
                </button>
              ) : (
                <>
                  {user.myStatus === null && user.friendStatus === "accepted" ? (
                    followedUsers[user.id] ? (
                      <>
                        <button
                          className="follow-cta my-2 bg-[#BE1F2E]"
                          onClick={() => handleUnfollow(user.id)}
                        >
                          Unfollow
                        </button>
                        <button
                          className="follow-cta-block my-2 bg-[#BE1F2E]"
                          onClick={() => handleBlockFollower(user.id)}
                        >
                          Block
                        </button>
                      </>
                    ) : (
                      <button
                        className="follow-cta my-2 bg-[#095228]"
                        onClick={() => handleFollowBack(user.id)}
                      >
                        Follow Back
                      </button>
                    )
                  ) : (
                    <button
                      className="follow-cta-block my-2 bg-[#BE1F2E]"
                      onClick={() => handleBlockFollower(user.id)}
                    >
                      Block
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        ))
      ) : (
        <p className="text-center text-gray-500 mt-4">You have no followers.</p>
      )}
    </div>
  )}
              </div>
            </div>
            <div className="md:hidden">
              {/* Right Sidebar */}
              <aside className="rightsidebar rig-sidebar-frnds-followers w-80 bg-white p-3  follow-aside">
                <div className="right-sidebar-fixed">
                  <h3 className="followers-title mb-4">Based on Your Followers</h3>
                  {[1, 2, 3, 4].map((user) => (
                    <div key={user} className=" followers">
                      <div className="flex followers-content">
                        <div class="flex">
                          <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                          <div className="pl-4">
                            <p className="titlesemibold pb-1">Marketing Group</p>
                            <p className="text-[12px] text-[#747474] pb-1">@prvnk_sky</p>
                            <p className="members">
                              764 Followers <span className="text-[#D9D9D9]">|</span>{" "}
                              <span className="italic text-[#095228b8] text-[10px] underline">4 Mutual Followers</span>
                            </p>
                          </div>
                        </div>
                        <button className="follow-cta">Follow</button>
                      </div>
                    </div>
                  ))}
                  {/* <hr></hr> */}
                  <h3 className="font-semibold mt-6 mb-4">Based on Your Groups</h3>
                  {[1, 2, 3].map((group) => (
                    <div key={group} className="followers ">
                      <div className="flex followers-content">
                        <div class="flex">
                          <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                          <div className="pl-4">
                            <p className="titlesemibold pb-1">Marketing Group</p>
                            <p className="text-[12px] text-[#747474] pb-1">@prvnk_sky</p>
                            <p className="members">
                              764 Followers <span className="text-[#D9D9D9]">|</span>{" "}
                              <span className="italic text-[#095228b8] text-[10px] underline">4 Mutual Followers</span>
                            </p>
                          </div>
                        </div>
                        <button className="follow-cta">Follow</button>
                      </div>
                    </div>
                  ))}

                </div>
              </aside>
              <p className="text-[#095228] text-[16px] text-center">© 2025 <b>Pipaan</b>. All Rights Reserved</p>
            </div>

          </div>
          {/* Right Sidebar */}
          <Rightsidebar />
        </main>
      </main>
    </div>
  );
}
